import { render, staticRenderFns } from "./ProgramSettingsFormControls.vue?vue&type=template&id=9a58cd26&lang=pug&"
import script from "./ProgramSettingsFormControls.vue?vue&type=script&lang=js&"
export * from "./ProgramSettingsFormControls.vue?vue&type=script&lang=js&"
import style0 from "./ProgramSettingsFormControls.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports